module.exports = __webpack_public_path__ + "img/networkCbt.20cfdce9.png";